export default "__VITE_ASSET__f42c5ad1__"